import { defineComponent } from "vue";
import StepBox from "../../components/StepBox";
import FormInfo from "../../components/FormInfo";
import InputText from "../../forms/InputText";
import InputCheckbox from "../../forms/InputCheckbox";
import Utils from "../../utils/Utils";
import Expander from "../../components/Expander";
import BlueInfoBox from "../../components/BlueInfoBox";
import Captcha from "../../utils/Captcha";
import DocLink from "../../components/DocLink";
import { OfferType } from "../../utils/OfferUtils";
import Tracking from "../../utils/Tracking";

export default defineComponent({
    components: {
        InputText,
        InputCheckbox,
        StepBox,
        FormInfo,
        Expander,
        DocLink,
        BlueInfoBox,
    },

    template: `
        <StepBox class="StepFormSummary"
            :step="3"
            :currentstep="step"
            title="Umowa"

            :valid="valid"
            :back="false"
            :error="sent ? options.valid_summary_error : null"

            label_next="Podpisz umowę teraz"

            @next="onNext"
        >
            <h3>Podsumowanie</h3>
            <FormInfo title="Oferta" :value="options.offer.title" />
            <FormInfo title="Okres obowiązywania" :value="pricewarrantytitle" />
            <FormInfo v-if="options.offer?.cashback" title="Bonus na start" :value="priceCashback" />

            <template v-if="options.offer?.prices.length == 1">
                <FormInfo title="Cena za kWh" :value="priceOffer1" />
            </template>

            <template v-if="options.offer?.prices.length == 2">
                <FormInfo title="Strefa dzienna" :value="priceOffer1" />
                <FormInfo title="Strefa nocna i weekendowa" :value="priceOffer2" />
            </template>

            <FormInfo title="Opłata handlowa w 2025 r." value="0,00 zł" />
            <FormInfo title="Opłata handlowa od 01.01.2026 r." :value="priceFee2" />

            <p class="StepFormSummary__feelegend">Opłata handlowa z uwzględnieniem rabatów za e-fakturę i zgody marketingowe</p>

            <FormInfo title="Deklarowane zużycie" :value="usage" />
            <FormInfo title="Długość umowy" :value="offerperiod" />
            <FormInfo title="Okres wypowiedzenia" :value="noticeperiod" />

            <hr>

            <h3>Podpisz dwa dokumenty i gotowe!</h3>
            <h4>Aby wszystko przebiegło sprawnie, do podpisania masz dwa dokumenty:</h4>

            <div class="StepFormSummary__maindocs">
                <DocLink title="Wzór umowy wraz z załącznikami" :url="contract_url" />

                <ul>
                    <li>Dane podstawowe dotyczące umowy</li>
                    <li>Ogólne warunki Umowy</li>
                    <li>Klauzula Informacyjna dla Klienta i Pełnomocnika</li>
                    <li>Oświadczenie Klienta o wyborze Sprzedawcy rezerwowego</li>
                    <li>Cennik podstawowy</li>
                    <li>Oświadczenie o wyborze produktu</li>
                    <li>Pełnomocnictwo dla Pełnomocnika Klienta</li>
                    <li>Oświadczenie o odstąpieniu od umowy zawartej na odległość</li>
                    <li v-if="options.offer.id >= 300 && options.offer.id <= 399">Regulamin Voucherów Promocyjnych</li>
                    <li v-if="options.offer.id >= 500 && options.offer.id <= 799">Regulamin Voucherów Promocyjnych</li>
                </ul>

                <DocLink title="Wzór pełnomocnictwa do zmiany sprzedawcy" url="/files/dokumenty/2024/1/pelnomocnictwo.pdf" />
            </div>

            <Expander :expanded="false">
                <template #widget>
                    <h4>Pozostałe dokumenty związane z Twoją Umową</h4>
                </template>

                <DocLink title="Klauzula Informacyjna" url="/files/dokumenty/2024/11/klauzula_informacyjna.pdf" />
                <DocLink title="Zbiór Praw Konsumenta" url="/files/dokumenty/2024/1/zbior_prawa_konsumenta.pdf" />
            </Expander>

            <BlueInfoBox class="BlueInfoBox--summary">
                <div><b>PAMIĘTAJ!</b> Podczas podpisywania dokumentów musisz podpisać 2 dokumenty:</div>

                <ol>
                    <li>Umowę na dostawę energii</li>
                    <li>Pełnomocnictwo do zmiany sprzedawcy.</li>
                </ol>
            </BlueInfoBox>

            <template #footer>
                <p class="StepFormSummary__footerinfo">lub zrób to w ciągu najbliższych 3 dni.</p>
            </template>

            <Teleport to=".content">
                <div v-if="loading" class="StepLoader">
                    <div class="StepLoader__inner">
                        <div class="OfferLoader">
                            <svg width="91" height="107" viewBox="0 0 91 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M50.6218 3.5L6.08909 56.9393C4.34504 59.0321 3.47302 60.0785 3.4597 60.9623C3.44811 61.7306 3.79046 62.4615 4.38809 62.9445C5.07555 63.5 6.43769 63.5 9.16198 63.5H45.6218L40.6218 103.5L85.1545 50.0607C86.8986 47.9679 87.7706 46.9215 87.7839 46.0377C87.7955 45.2694 87.4531 44.5385 86.8555 44.0555C86.1681 43.5 84.8059 43.5 82.0816 43.5H45.6218L50.6218 3.5Z" stroke="#96ff00" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <p><b>Generujemy dla Ciebie DWA dokumenty:<br>Umowę i Pełnomocnictwo</b></p>
                        <p>
                            PAMIĘTAJ! Podczas podpisywania dokumentów, musisz podpisać dwa dokumenty:<br>
                            Umowę na dostawę energii<br>
                            Pełnomocnictwo do zmiany sprzedawcy.
                        </p>
                    </div>
                </div>
            </Teleport>
        </StepBox>
    `,

    emits: [
        'next',
    ],

    props: {
        /** @var Json */
        options: { type: Object, required: true },
        step: { type: Number, required: true },
    },

    data() {
        return {
            error: null,

            sent: false,
            loading: false,
        };
    },

    computed: {
        valid() {
            return this.options.valid;
        },

        promotitle() {
            return 'Pierwsze ' + this.options.offer.discount_period + ' miesięcy 1gr/kWh';
        },

        priceCashback() {
            return Utils.priceFormat(this.options.offer?.cashback, true, ' zł');
        },

        priceOffer1() {
            return Utils.priceFormat(this.options.offer.prices[0].price, false, '', 4);
        },

        priceOffer2() {
            return Utils.priceFormat(this.options.offer.prices[1].price, false, '', 4);
        },

        priceFee2() {
            return Utils.priceFormat(this.options.feenext, false, ' zł');
        },

        usage() {
            return this.options.usage + ' kWh / rok';
        },

        pricewarrantytitle() {
            return this.options.offer?.price_warranty ? Utils.yearsTitle(this.options.offer?.price_warranty) : null;
        },

        offerperiod() {
            return this.options.offer?.period ? Utils.yearsTitle(this.options.offer.period) : 'Czas nieoznaczony';
        },

        noticeperiod() {
            return Utils.monthsTitle(this.options.noticeperiod ?? 1);
        },

        contract_url() {
            switch (this.options.offer.type) {
                case OfferType.OFFERTYPE_BPM:
                    return '/files/dokumenty/2025/01/B2C.Umowa.kompleksowa.BP.010125B.pdf';

                case OfferType.OFFERTYPE_FP:
                    return '/files/dokumenty/2025/01/B2C.Umowa.kompleksowa.FP.010125B.pdf';

                default:
                    return null;
            }
        },
    },

    mounted() {
        if (this.options.captchakey) {
            Captcha.init(this.options.captchakey);
        }
    },

    methods: {
        async onNext() {
            try {
                this.error = null;
                this.loading = true;

                const token = this.options.captchakey ? await Captcha.submit(this.options.captchakey) : null;

                Tracking.doEvent('click_personaldata_confirmation');

                const r = await Utils.setCart('summary', {
                    token: token,
                });

                this.sent = true;

                if (r.redirect) {
                    window.location.href = r.redirect;
                } else {
                    this.loading = false;
                }
            } catch (e) {
                this.error = e.message;
                this.loading = false;
            }
        },
    },
});
